import Dom from '../utility/dom';

/**
 * Set css custom properties to the body
 */
export function setCustomProperties() {
  const setCSSProps = () => {
    // Window Size Helpers
    Dom.body.style.setProperty('--window-width', window.innerWidth + 'px');
    Dom.body.style.setProperty('--window-height', window.innerHeight + 'px');
    Dom.body.style.setProperty('--window-width-int', window.innerWidth);
    Dom.body.style.setProperty('--window-height-int', window.innerHeight);

    // Notification Bar
    const notificationBar = document.querySelector('.header_notification_bar');
    if(!!notificationBar){
      Dom.body.style.setProperty('--notification-bar-height', Math.round(notificationBar.getBoundingClientRect().height) + 'px');
    }
  }
  setCSSProps();

  window.addEventListener('resize', function(){
    setCSSProps();
  });
}


/**
 * Set css custom properties for use in the editor
 */
export function setCustomPropertiesEditor() {
  const setCSSProps = () => {
    const body = document.querySelector('body');
    const editor = document.querySelector('.editor-styles-wrapper');

    if(!!editor){
      // Window Size Helpers
      Dom.body.style.setProperty('--window-width', editor.clientWidth + 'px');
      Dom.body.style.setProperty('--window-height', window.innerHeight + 'px');
      Dom.body.style.setProperty('--window-width-int', editor.clientWidth);
      Dom.body.style.setProperty('--window-height-int', window.innerHeight);
    }
  }
  setCSSProps();

  window.addEventListener('resize', function(){
    setCSSProps();
  });
}